<template>
  <div ref="zlBox" v-show="show">
    <div class="mask" @touchmove="preventDefault($event)"></div>
    <div class="zhuli-detail">
      <img src="~common/image/zhuli-bg.png" class="bg-img">
      <div class="content">
        <!--<div @touchmove="preventDefault($event)">-->
          <div class="close" @click="close"></div>
          <div class="avatar">
            <div>
              <img v-lazy="data.assist_user_avatar">
            </div>
          </div>
          <div class="title-wrap">
            <div class="img">
              <div>
                <img v-lazy="data.course_avatar">
              </div>
            </div>
            <div class="blank"></div>
            <div class="title">{{data.course_title}}</div>
          </div>
          <div class="card-wrap" :class="{'jc-left': ((data.join_user_avatar?data.join_user_avatar.length:0)+data.left_user_count) === 2}">
            <div class="col" v-for="(item, i) in data.join_user_avatar" :key="i">
              <div>
                <img v-lazy="item" alt="">
              </div>
            </div>
            <div class="col" v-for="i in (new Array(data.left_user_count))" :key="i">
              <div>
                <img src="~common/image/wenhao.png" alt="">
              </div>
            </div>
          </div>
          <div class="info-wrap" v-if="data.status === 1 || data.status === '1'">再分享给{{data.left_user_count}}人可免费观看!</div>
        <div class="info-wrap" v-if="data.status === 2 || data.status === '2'">解锁成功!</div>
          <div class="btn-wrap" v-if="data.is_assistor === 1">
            <!-- 未完成 -->
            <div>
              <a href="javascript:;" @click="btn1Click">马上发送给好友</a>
            </div>
          </div>
          <!-- 已完成 -->
          <div class="btn-wrap success" v-else-if="data.is_assistor === 0">
            <div>
              <a href="javascript:;" @click="btn2Click">助力成功! 我也要免费观看</a>
            </div>
          </div>
          <div class="btn-wrap lose" v-else>
            <div>
              <a href="javascript:;">已失效</a>
            </div>
          </div>
          <div class="end-wrap" v-if="data.status === 1 || data.status === '1'">距离失效还剩  <span>{{remainingTime}}</span></div>
        <!--</div>-->
        <div class="desc-wrap">
          <div>
            <div class="title">
              <div>活动规则</div>
              <div @click="showDesc=!showDesc">&gt;</div>
            </div>
            <div class="list" v-if="showDesc">
              <div>1、成功邀请{{(data.join_user_avatar?data.join_user_avatar.length:0) + data.left_user_count}}个人帮助解锁即可免费观看视频。</div>
              <div>2、每个好友仅可解锁1次。</div>
              <div>3、课程免费观看时长为解锁后{{kcData.expire_day}}天内</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import {getRemaining} from '@/utils/dateUtil'
export default {
  props: {
    data: {
      type: Object,
      default: null
    },
    kcData: {
      type: Object,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDesc: false,
      remainingTime: ''
    }
  },
  created() {
    // console.log('助力弹框created')
  },
  mounted() {
  },
  methods: {
    preventDefault(event) {
      event.preventDefault()
      event.stopPropagation()
    },
    close() {
      this.$emit('close')
    },
    btn1Click() {
      this.$emit('btn1Click')
    },
    btn2Click() {
      this.$emit('btn2Click')
    }
  },
  watch: {
    show(n) {
      if (n) {
        this.timer = setInterval(() => {
          this.remainingTime = getRemaining(this.data.end_time_seconds--, true)
        }, 1000)
      } else {
        clearInterval(this.timer)
        this.remainingTime = ''
      }
    }
  }
}
</script>
<style scoped lang="stylus">
  @import "~common/stylus/variable"
  $p(val)
    val/640*100%
  .mask{
    position fixed
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .3)
    z-index 998
  }
  .zhuli-detail{
    width: 80%;
    position fixed
    top: 50%;
    left: 50%;
    z-index 999
    -webkit-transform: translate(-50%, -50%)
    -moz-transform: translate(-50%, -50%)
    -ms-transform: translate(-50%, -50%)
    -o-transform: translate(-50%, -50%)
    transform: translate(-50%, -50%)
    .bg-img{
      width: 100%;
    }
    .content{
      position absolute
      top: 0;
      left: 0;
      width: 100%;
      $widht = 640;
      .close{
        position absolute
        width: $p(56)
        left: $p(584)
        padding-bottom: $p(56)
      }
      .avatar{
        position absolute
        width: $p(110)
        padding-bottom: $p(110)
        left: $p(40)
        margin-top: $p(46)
        >div{
          position absolute
          width: 100%;
          height: 100%;
          background-color: #fff
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
          border-radius: 50%;
          // padding: 1px;
          overflow hidden
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
      .title-wrap{
        position absolute
        margin-top: $p(240)
        left: $p(75)
        width: $p(490)
        display flex
        flex-direction row
        flex-wrap nowrap
        align-items center
        .img{
          width: (170/490) * 100%;
          padding-bottom: (100/490) * 100%;
          position relative
          img{
            position absolute;
            top: 0;
            left: 0;
            width: 100%;
            height 100%;
            -webkit-border-radius: size(10)
            -moz-border-radius: size(10)
            border-radius: size(10)
          }
        }
        .blank{
          width: (30/490) * 100%;
        }
        .title{
          width: (290/490) * 100%;
          font-size size(30)
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 1.2;
          font-weight 600
        }
      }
      .card-wrap{
        &.jc-left{
          justify-content: flex-start
          .col{
            margin-right: 1rem;
          }
        }
        position absolute
        margin-top: $p(436)
        left: $p(80)
        width: $p(474)
        display flex
        flex-direction row
        flex-wrap nowrap
        align-items center
        justify-content space-between
        .col{
          width: (80/467) * 100%
          padding-bottom (80/467) * 100%
          position relative
          img{
            position absolute
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
          }
        }
      }
      .info-wrap{
        position absolute
        margin-top: $p(540)
        left: $p(80)
        width: $p(480)
        text-align center
        font-size size(30)
        font-weight 600
        line-height 1.2
      }
      .btn-wrap{
        position absolute
        margin-top: $p(625)
        left: $p(147)
        width: $p(350)
        text-align center
        font-size size(30)
        font-weight 600
        padding-bottom: $p(70)
        >div{
          position absolute
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #2dd696
          -webkit-border-radius: size(50)
          -moz-border-radius: size(50)
          border-radius: size(50)
          a{
            position absolute
            width: 100%;
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%)
            -moz-transform: translate(-50%, -50%)
            -ms-transform: translate(-50%, -50%)
            -o-transform: translate(-50%, -50%)
            transform: translate(-50%, -50%)
            color: #fff;
            font-size size(30)
          }
        }
        &.success{
          left: $p(94)
          width: $p(450)
        }
        &.lose{
          >div{
            background-color: #ddd
          }
        }
      }
      .end-wrap{
        position absolute
        margin-top: $p(735)
        left: 0
        width: 100%;
        text-align center
        color: #999999
        font-size size(26)
        span{
          color: #ff6c00;
        }
      }
      .desc-wrap{
        position absolute
        margin-top: $p(840)
        left: 0
        width: 100%;
        background-color: #fe992d
        -webkit-border-radius: size(10)
        -moz-border-radius: size(10)
        border-radius: size(10)
        font-size size(24)
        color: #fff
        >div{
          padding-left: $p(55)
          padding-right: $p(55)
          padding-bottom: $p(20)
          .title{
            display flex
            justify-content space-between
          }
          .list{
            padding: $p(20) 0
            line-height 1.4
            height 5em
            overflow-y scroll
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/base/activity/zhuli/detail.vue